import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import {
   jobGroupJobfeedForPartnerAutoCompleteInput$,
   jobGroupJobfeedForPartnerAutoCompleteObservable$,
} from 'app/employer/redux/autosuggest/autoCompleteService';

const JobGroupJobfeedForPartnerAutosuggest = renderAutoSuggestWithOptions(
   jobGroupJobfeedForPartnerAutoCompleteObservable$,
   jobGroupJobfeedForPartnerAutoCompleteInput$,
);

JobGroupJobfeedForPartnerAutosuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: [],
   filterHiringCompany: [],
   forceSelection: false,
   placeholder: 'Search JobGroup...',
};

export default JobGroupJobfeedForPartnerAutosuggest;
